import React from 'react'
import pluralize from 'pluralize'
import { CustomerSeats } from '../../store/plan/plan'
import { Spinner } from 'react-bootstrap'

export interface AvailableSeatsInfoProps {
  seats?: CustomerSeats
  isFetching: boolean
  isError: boolean
}

export const AvailableSeatsInfo = ({ seats, isFetching, isError }: AvailableSeatsInfoProps) => {
  return (
    <>
      {!isError && !isFetching && seats ? (
        <>
          You have <b>{seats.general.available}</b> {pluralize('seat', seats.general.available)} and <b>{seats.sidecar.available}</b> Administrative Assistant{' '}
          {pluralize('seat', seats.sidecar.available)} available.
        </>
      ) : null}
      {isFetching ? <Spinner /> : null}
      {isError ? <>Unable to fetch free seats information</> : null}
    </>
  )
}
